<template>
  <el-select
    class="service-selector"
    :value="serviceId"
    @input="handleChangeService"
    filterable
    :disabled="disabled"
    placeholder="เลือกบริการ"
    clearable
  >
    <el-option
      class="service-select-option"
      v-for="item in serviceOptions"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    >
      <p>
        {{ item.name }}
        <br />
        <small>{{ item.shortDescription }}</small>
      </p>
    </el-option>
  </el-select>
</template>

<script>
import axios from "axios";
import { Select, Option } from "element-ui";
import { baanRueJaiClient } from "@/dependencies";

export default {
  components: {
    "el-select": Select,
    "el-option": Option
  },
  props: ["value", "initialServices", "disabled", "provider"],
  data() {
    const services = [];

    return {
      services
    };
  },
  computed: {
    serviceOptions() {
      if (!this.provider) {
        return this.services;
      }

      return this.services.filter(service => {
        return service.provider.id === this.provider.id;
      });
    },
    serviceId() {
      if (!this.value) {
        return null;
      }

      return this.value.id;
    }
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupServices();
    },
    async setupServices() {
      const services = await this.fetchServices();

      this.services = services.map(service => {
        const {
          id,
          name,
          short_description: shortDescription,
          description,
          icon_url: iconUrl
        } = service;
        const provider = {
          ...service.provider,
          logoUrl: service.provider.logo_url
        };

        return {
          id,
          iconUrl,
          name,
          shortDescription,
          description,
          provider
        };
      });
    },
    async fetchServices() {
      if (this.initialServices) {
        return this.initialServices;
      }

      const response = await baanRueJaiClient.admin.subscriptions.services.list();

      return response.data.result;
    },
    handleChangeService(serviceId) {
      const service = this.services.find(service => service.id === serviceId);

      this.$emit("input", service);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.service-selector {
  width: 100%;
}

.service-select-option {
  margin: 0;

  padding-top: 8px;
  padding-bottom: 8px;
  height: 52px;

  > p {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/lib/components/ServiceSelect.vue